import { ExportButton, TopToolbar } from 'react-admin';
import React from 'react';

export const ListActions: React.FC = () => (
  <TopToolbar>
    <ExportButton maxResults={ 100000 } />
  </TopToolbar>
)
